<!--
Locations > building to screen
@author bmk11u, crm4f
-->
<template>
    <div id="contain" class="container">

    <Logo v-if="!authenticated" data-test="logo" />
    <div v-if="!authenticated" class="mb-1" ></div>

    <Nav name="Find a Building or Room" :back="authenticated===true" :step="true"/>

    <StaggeredSearch :authenticated="authenticated===true"/>

    <div id="pusher"></div>
    <Footer active="locations" v-if="authenticated"/>
  </div>
</template>

<script setup>
import Logo from '@/components/Logo.vue'
import Footer from '@/components/FooterMenu.vue'
import StaggeredSearch from '@/views/roomfinder/StaggeredSearch.vue';
import { useLocationsCommon } from '@/composables/LocationsCommon.js'

const { authenticated } = useLocationsCommon()
</script>
